import api from '../../api/client';
// src/pages/accountant/ReconciliationReports.jsx
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { HiDocumentDownload } from "react-icons/hi";
// import Select from "react-select";
// import DataTable from "react-data-table-component";
// import { Row, Col, Button, Spinner, ListGroup } from "react-bootstrap";
// import MainCard from "../../components/Card/MainCard";
// import config from "../../config";

// export default function ReconciliationReports() {
//   const [reports, setReports] = useState([]);
//   const [filteredReports, setFilteredReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [discrepancies, setDiscrepancies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filterOptions, setFilterOptions] = useState([]);

//   const environment =
//     window.location.hostname === "localhost" ? "development" : "production";
//   const apiUrl = config[environment].apiUrl;

//   useEffect(() => {
//     fetchReports();
//   }, []);

//   const fetchReports = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get(`/reconciliation/reports`);
//       setReports(res.data);
//       setFilteredReports(res.data);

//       // Generate dropdown filter options
//       const options = res.data.map((r) => ({
//         value: r.bank_account,
//         label: r.bank_account,
//       }));

//       console.log(res.data);
//       setFilterOptions([...new Map(options.map((o) => [o.value, o])).values()]);
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchReportDetails = async (reportId) => {
//     setLoading(true);
//     try {
//       const res = await api.get(
//         `/reconciliation/reports/${reportId}`,
//       );
//       console.log(res.data);
//       setSelectedReport(res.data);
//       setDiscrepancies(res.data.discrepancies);
//     } catch (error) {
//       console.error("Error fetching report details:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFilterChange = (selected) => {
//     if (!selected) {
//       setFilteredReports(reports);
//     } else {
//       setFilteredReports(
//         reports.filter((r) => r.bank_account === selected.value),
//       );
//     }
//   };

//   const discrepancyColumns = [
//     {
//       name: "Date",
//       selector: (row) => new Date(row?.transaction_date)?.toLocaleDateString(),
//       sortable: true,
//     },
//     { name: "Description", selector: (row) => row?.description },
//     { name: "Reference", selector: (row) => row?.reference },
//     {
//       name: "Amount",
//       selector: (row) => row?.amount,
//       cell: (row) => (
//         <span className={row?.amount > 0 ? "text-success" : "text-danger"}>
//           {row?.amount?.toLocaleString()}
//         </span>
//       ),
//       right: true,
//     },
//     {
//       name: "Type",
//       selector: (row) =>
//         row?.type === "system" ? "System Transaction" : "Bank Transaction",
//     },
//   ];

//   return (
//     <React.Fragment>
//       <Row>
//         <Col lg={3}>
//           <MainCard title="All Reports" className="mb-3">
//             <Select
//               options={filterOptions}
//               isClearable
//               placeholder="Filter by Bank Account"
//               onChange={handleFilterChange}
//               className="mb-3"
//             />

//             {loading && reports?.length === 0 ? (
//               <div className="text-center py-3">
//                 <Spinner animation="border" size="sm" /> Loading reports...
//               </div>
//             ) : reports?.length === 0 ? (
//               <div className="text-center text-muted py-3">
//                 No reports found
//               </div>
//             ) : (
//               <ListGroup>
//                 {filteredReports &&
//                   filteredReports?.map((report) => (
//                     <ListGroup.Item
//                       key={report.id}
//                       action
//                       active={selectedReport?.id === report.id}
//                       onClick={() => fetchReportDetails(report.id)}
//                     >
//                       <div className="fw-bold">
//                         {report.bank_account} •{" "}
//                         {new Date(report.statement_date).toLocaleDateString()}
//                       </div>
//                       <small className="text-muted">
//                         Reconciled on{" "}
//                         {new Date(report.reconciled_at).toLocaleDateString()}
//                       </small>
//                       <div className="d-flex justify-content-between mt-1">
//                         <span
//                           className={
//                             report.discrepancy === 0
//                               ? "text-success"
//                               : "text-danger"
//                           }
//                         >
//                           Discrepancy: {report.discrepancy.toLocaleString()}
//                         </span>
//                         <span className="badge bg-light text-dark">
//                           {report.unreconciled_count} unreconciled
//                         </span>
//                       </div>
//                     </ListGroup.Item>
//                   ))}
//               </ListGroup>
//             )}
//           </MainCard>
//         </Col>

//         <Col lg={9}>
//           {selectedReport ? (
//             <MainCard
//               title={`Reconciliation Report • ${new Date(
//                 selectedReport.statement_date,
//               ).toLocaleDateString()}`}
//               secondary={
//                 <Button variant="success" size="sm">
//                   <HiDocumentDownload className="me-1" />
//                   Export Report
//                 </Button>
//               }
//             >
//               <p className="text-muted mb-4">
//                 Reconciled by {selectedReport.reconciled_by_name} on{" "}
//                 {new Date(selectedReport.reconciled_at).toLocaleDateString()}
//               </p>

//               <Row className="mb-4">
//                 {selectedReport &&
//                   Object.entries(selectedReport).map(([key, value]) => {
//                     if (
//                       [
//                         "id",
//                         "reconciled_by_name",
//                         "statement_date",
//                         "reconciled_at",
//                       ].includes(key)
//                     ) {
//                       return null;
//                     }
//                     return (
//                       <Col md={4} key={key} className="mb-3">
//                         <div className="border p-3 rounded">
//                           <small className="text-muted text-capitalize">
//                             {key.replace(/_/g, " ")}
//                           </small>
//                           <div
//                             className={`fs-5 fw-bold ${
//                               key === "discrepancy"
//                                 ? value === 0
//                                   ? "text-success"
//                                   : "text-danger"
//                                 : ""
//                             }`}
//                           >
//                             {typeof value === "number"
//                               ? value.toLocaleString()
//                               : value?.toString?.()}
//                           </div>
//                         </div>
//                       </Col>
//                     );
//                   })}
//               </Row>

//               <h5>Unreconciled Transactions</h5>
//               {discrepancies && discrepancies?.length === 0 ? (
//                 <div className="text-success py-4">
//                   All transactions were successfully reconciled!
//                 </div>
//               ) : (
//                 <DataTable
//                   columns={discrepancyColumns}
//                   data={discrepancies}
//                   pagination
//                   highlightOnHover
//
//                 />
//               )}
//             </MainCard>
//           ) : (
//             <div className="text-muted">Select a report to view details.</div>
//           )}
//         </Col>
//       </Row>
//     </React.Fragment>
//   );
// }

// src/pages/accountant/ReconciliationReport.jsx
import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Badge } from "react-bootstrap";
import { HiDocumentDownload } from "react-icons/hi";
import axios from "axios";
import config from "../../config";
import DataTable from "react-data-table-component";

export default function ReconciliationReport() {
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [details, setDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    setIsLoading(true);
    try {
      const response = await api.get(`/reconciliation/reports`);
      setReports(response.data);
    } catch (error) {
      console.error("Error fetching reports:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchReportDetails = async (reportId) => {
    setIsLoading(true);
    try {
      const response = await api.get(
        `/reconciliation/reports/${reportId}`,
      );
      setDetails(response.data);
      setSelectedReport(reportId);
    } catch (error) {
      console.error("Error fetching report details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadReport = async (reportId) => {
    try {
      const response = await api.get(
        `/reconciliation/reports/${reportId}/export`,
        { responseType: "blob" },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `reconciliation-report-${reportId}.pdf`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.error("Error downloading report:", error);
      alert("Error downloading report");
    }
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => new Date(row.transaction_date).toLocaleDateString(),
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Reference",
      selector: (row) => row.reference,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.amount,
      format: (row) => (
        <span className={row.amount > 0 ? "text-success" : "text-danger"}>
          {row.amount.toLocaleString()}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <Badge
          bg={row.reconciled ? "success" : "danger"}
          className="text-capitalize"
        >
          {row.reconciled ? "Reconciled" : "Unreconciled"}
        </Badge>
      ),
      sortable: true,
    },
  ];

  return (
    <React.Fragment>
      {/* <h1 className="h2 mb-4">Reconciliation Reports</h1> */}

      <Row>
        <Col md={4}>
          <div className="bg-white rounded shadow-sm mb-4">
            <div className="p-3 border-bottom bg-light">
              <h5 className="mb-0">Generated Reports</h5>
            </div>
            <div className="overflow-auto" style={{ maxHeight: "60vh" }}>
              {reports.length === 0 ? (
                <div className="p-4 text-center text-muted">
                  No reports available
                </div>
              ) : (
                reports.map((report) => (
                  <div
                    key={report.id}
                    className={`p-3 border-bottom cursor-pointer ${
                      selectedReport === report.id ? "bg-light" : ""
                    }`}
                    onClick={() => fetchReportDetails(report.id)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-bold">{report.bank_account}</div>
                        <div className="small text-muted">
                          {new Date(report.statement_date).toLocaleDateString()}
                        </div>
                      </div>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadReport(report.id);
                        }}
                      >
                        <HiDocumentDownload />
                      </Button>
                    </div>
                    <div className="mt-2">
                      <Badge bg="info" className="me-1">
                        {report.reconciled_count} Reconciled
                      </Badge>
                      <Badge bg="warning" className="me-1">
                        {report.unreconciled_count} Unreconciled
                      </Badge>
                      <Badge
                        bg={report.discrepancy === 0 ? "success" : "danger"}
                      >
                        Discrepancy: {report.discrepancy.toLocaleString()}
                      </Badge>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </Col>

        <Col md={8}>
          {selectedReport ? (
            <div className="bg-white rounded shadow-sm">
              <div className="p-3 border-bottom bg-light d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Reconciliation Details</h5>
                <Button
                  variant="primary"
                  onClick={() => downloadReport(selectedReport)}
                >
                  <HiDocumentDownload className="me-1" /> Export PDF
                </Button>
              </div>
              <div className="p-3">
                <DataTable
                  columns={columns}
                  data={details}
                  progressPending={isLoading}
                  pagination
                  highlightOnHover
                />
              </div>
            </div>
          ) : (
            <div className="bg-white rounded shadow-sm p-5 text-center text-muted">
              <h4>Select a report to view details</h4>
              <p>
                Click on a report in the list to see its reconciliation details
              </p>
            </div>
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
}
